module.exports = __webpack_public_path__ + "static/media/status-broadcasted.62ca9883.svg";